import { useOnboardingContext } from '../context/OnboardingProvider';
import { StepRuntime } from './types/types';

import { useSearchParams } from 'react-router-dom';

export default function OnboardingShell(): JSX.Element {
  const { state, next, saveStep, clearStep, restart, visible } = useOnboardingContext();
  // Validate that the current step matches the slug
  const [searchParams] = useSearchParams();
  const slug = searchParams.get('slug');
  const step = visible.find((step) => step.slug === slug);
  const StepComponent = (step?.Component as React.FC<StepRuntime>) ?? visible[0].Component;

  return (
    <StepComponent
      next={next}
      saveStep={saveStep}
      clearStep={clearStep}
      restart={restart}
      context={state}
    />
  );
}
